import React from 'react';
import { TimeRateDto } from 'src/api/v2';
import useTimeRates from 'src/hooks/use-time-rates';

type Props = {
  timerate: TimeRateDto | undefined;
};

const ContactsTimerate = ({ timerate }: Props) => {
  const { timeRates, defaultTimeRate } = useTimeRates();

  if (!timerate) {
    return <></>;
  }
  const found = timeRates?.find((x) => x.id === timerate?.id);
  if (found) {
    return <span>{`${found.name} (${found.hourRate.toLocaleString('nb')} kr)`}</span>;
  } else if (defaultTimeRate) {
    return <span>{`${defaultTimeRate.name} (${defaultTimeRate.hourRate.toLocaleString('nb')} kr)`}</span>;
  } else {
    return <></>;
  }
};

export default ContactsTimerate;
